import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@mui/material/Slide';
import { AppBar, Toolbar } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { removeQuery } from 'Helpers/Query';
import closeModal from 'Helpers/ModalHelper';
import RemindersBase from 'Components/AdvisorApp/Viewport/TodayDashboard/RemindersBase';

const styles = theme => ({
  root: {},
  appBar: {
    position: 'relative',
  },
  reminders: {
    margin: theme.spacing(2),
  },
});

const Transition = React.forwardRef((props, ref) => <Slide direction="up" ref={ref} {...props} />);

const closeDialog = () => {
  removeQuery('remindersLink');
  closeModal();
};

const RemindersDialog = ({ classes }) => {
  return (
    <Dialog
      className={classes.root}
      open
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton edge="start" color="inherit" onClick={closeDialog} aria-label="close">
            <CloseIcon />
          </IconButton>
          <Typography variant="h3" className={classes.title}>Reminders</Typography>
        </Toolbar>
      </AppBar>
      <RemindersBase className={classes.reminders} expanded />
    </Dialog>
  );
};

RemindersDialog.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(RemindersDialog);
